"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _DropdownOptions = _interopRequireDefault(require("../DropdownOptions"));

var _table = require("./table.proptypes");

var _constant = require("./constant");

var _Label = _interopRequireDefault(require("../Label"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var MainWrapper = _styledComponents.default.table.withConfig({
  displayName: "Table__MainWrapper",
  componentId: "sc-1kbzrgp-0"
})(["width:100%;border-collapse:collapse;table-layout:", ";"], function (_ref) {
  var isTableFixed = _ref.isTableFixed;
  return isTableFixed ? _constant.TABLE_LAYOUT.fixed : _constant.TABLE_LAYOUT.auto;
});

var TableBody = _styledComponents.default.tbody.withConfig({
  displayName: "Table__TableBody",
  componentId: "sc-1kbzrgp-1"
})([""]);

var TableHead = _styledComponents.default.thead.withConfig({
  displayName: "Table__TableHead",
  componentId: "sc-1kbzrgp-2"
})([""]);

var HeaderWrapper = _styledComponents.default.th.withConfig({
  displayName: "Table__HeaderWrapper",
  componentId: "sc-1kbzrgp-3"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";padding:", ";text-align:", ";box-sizing:", ";width:", ";"], function (_ref2) {
  var theme = _ref2.theme,
      family = _ref2.family;
  return theme.fontFamily[family];
}, function (_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size;
  return theme.fontSize[size];
}, function (_ref4) {
  var theme = _ref4.theme,
      weight = _ref4.weight;
  return theme.fontWeight[weight];
}, function (_ref5) {
  var theme = _ref5.theme,
      height = _ref5.height;
  return theme.lineHeight[height];
}, function (_ref6) {
  var theme = _ref6.theme,
      color = _ref6.color;
  return theme.colors[color];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.backgroundColor.greyLighter;
}, function (_ref8) {
  var theme = _ref8.theme,
      padding = _ref8.padding;
  return !padding ? "".concat(theme.space.XSmall, " ").concat(theme.space.standard) : padding;
}, function (_ref9) {
  var alignment = _ref9.alignment;
  return alignment;
}, function (_ref10) {
  var boxSizing = _ref10.boxSizing;
  return boxSizing;
}, function (_ref11) {
  var width = _ref11.width;
  return width;
});

var SubheaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "Table__SubheaderWrapper",
  componentId: "sc-1kbzrgp-4"
})(["display:flex;flex-direction:column;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";padding:", ";text-align:", ";"], function (_ref12) {
  var theme = _ref12.theme,
      family = _ref12.family;
  return theme.fontFamily[family];
}, function (_ref13) {
  var theme = _ref13.theme,
      size = _ref13.size;
  return theme.fontSize[size];
}, function (_ref14) {
  var theme = _ref14.theme,
      weight = _ref14.weight;
  return theme.fontWeight[weight];
}, function (_ref15) {
  var theme = _ref15.theme,
      height = _ref15.height;
  return theme.lineHeight[height];
}, function (_ref16) {
  var theme = _ref16.theme,
      color = _ref16.color;
  return theme.colors[color];
}, function (_ref17) {
  var padding = _ref17.padding;
  return padding;
}, function (_ref18) {
  var alignment = _ref18.alignment;
  return alignment;
});

var RowWrapper = _styledComponents.default.tr.withConfig({
  displayName: "Table__RowWrapper",
  componentId: "sc-1kbzrgp-5"
})(["border-bottom:", ";"], function (_ref19) {
  var theme = _ref19.theme,
      showBorder = _ref19.showBorder;
  return showBorder ? "1px solid ".concat(theme.colors.greyLight) : '0px';
});

var RowWrapperAction = _styledComponents.default.tr.withConfig({
  displayName: "Table__RowWrapperAction",
  componentId: "sc-1kbzrgp-6"
})(["border-bottom:", ";cursor:pointer;"], function (_ref20) {
  var theme = _ref20.theme,
      bottomBorder = _ref20.bottomBorder;
  return bottomBorder ? "1px solid ".concat(theme.colors.greyLight) : '';
});

var ContentWrapper = _styledComponents.default.td.withConfig({
  displayName: "Table__ContentWrapper",
  componentId: "sc-1kbzrgp-7"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";padding:", ";text-align:", ";white-space:", ";overflow:", ";text-overflow:", ";max-width:", ";span{font-size:", ";font-weight:", ";color:", ";}"], function (_ref21) {
  var theme = _ref21.theme,
      family = _ref21.family;
  return theme.fontFamily[family];
}, function (_ref22) {
  var theme = _ref22.theme,
      size = _ref22.size;
  return theme.fontSize[size];
}, function (_ref23) {
  var theme = _ref23.theme,
      weight = _ref23.weight;
  return theme.fontWeight[weight];
}, function (_ref24) {
  var theme = _ref24.theme,
      height = _ref24.height;
  return theme.lineHeight[height];
}, function (_ref25) {
  var theme = _ref25.theme,
      color = _ref25.color;
  return theme.colors[color];
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.backgroundColor.default;
}, function (_ref27) {
  var theme = _ref27.theme,
      padding = _ref27.padding;
  return !padding ? "".concat(theme.space.XSmall, " ").concat(theme.space.standard) : padding;
}, function (_ref28) {
  var alignment = _ref28.alignment;
  return alignment;
}, function (_ref29) {
  var isEllipsis = _ref29.isEllipsis;
  return isEllipsis ? 'nowrap' : '';
}, function (_ref30) {
  var isEllipsis = _ref30.isEllipsis;
  return isEllipsis ? 'hidden' : '';
}, function (_ref31) {
  var isEllipsis = _ref31.isEllipsis;
  return isEllipsis ? 'ellipsis' : '';
}, function (_ref32) {
  var isEllipsis = _ref32.isEllipsis,
      ellipsisLength = _ref32.ellipsisLength;
  return isEllipsis ? ellipsisLength : null;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontSize.XSmall;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.fontWeight.normal;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.greyDark;
});

var ContentChildrenWrapper = _styledComponents.default.div.withConfig({
  displayName: "Table__ContentChildrenWrapper",
  componentId: "sc-1kbzrgp-8"
})(["display:inline-flex;align-items:start;gap:", ";"], function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.micro;
});

var ChildrenWrapper = _styledComponents.default.div.withConfig({
  displayName: "Table__ChildrenWrapper",
  componentId: "sc-1kbzrgp-9"
})([""]);

var FlexContainer = _styledComponents.default.div.withConfig({
  displayName: "Table__FlexContainer",
  componentId: "sc-1kbzrgp-10"
})(["display:flex;width:100%;max-width:170px;justify-content:space-between;flex-direction:", ";"], function (_ref37) {
  var isMobile = _ref37.isMobile;
  return isMobile ? 'column' : 'row';
});

var FlexColumn = _styledComponents.default.div.withConfig({
  displayName: "Table__FlexColumn",
  componentId: "sc-1kbzrgp-11"
})(["display:flex;justify-content:flex-start;"]);

var NotFirstColumn = _styledComponents.default.div.withConfig({
  displayName: "Table__NotFirstColumn",
  componentId: "sc-1kbzrgp-12"
})(["display:flex;justify-content:flex-start;font-family:", ";font-size:", ";font-weight:", ";color:", ";background-color:", ";text-align:", ";span{font-size:", ";font-weight:", ";color:", ";}"], function (_ref38) {
  var theme = _ref38.theme,
      family = _ref38.family;
  return theme.fontFamily[family];
}, function (_ref39) {
  var theme = _ref39.theme,
      size = _ref39.size;
  return theme.fontSize[size];
}, function (_ref40) {
  var theme = _ref40.theme,
      weight = _ref40.weight;
  return theme.fontWeight[weight];
}, function (_ref41) {
  var theme = _ref41.theme,
      color = _ref41.color;
  return theme.colors[color];
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.backgroundColor.default;
}, function (_ref43) {
  var alignment = _ref43.alignment;
  return alignment;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.fontSize.XSmall;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.fontWeight.normal;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.colors.greyDark;
});

var Table = function Table(props) {
  var theme = props.theme,
      translation = props.translation,
      accessible = props.accessible,
      customProperties = props.customProperties,
      columns = props.columns,
      data = props.data,
      withSubLabel = props.withSubLabel,
      isMobile = props.isMobile,
      isEllipsis = props.isEllipsis,
      ellipsisLength = props.ellipsisLength,
      rowsWithAction = props.rowsWithAction,
      dropdownOptionsProps = props.dropdownOptionsProps,
      _onOptionSelect = props.onOptionSelect,
      boxSizing = props.boxSizing,
      showBorder = props.showBorder,
      isTableFixed = props.isTableFixed,
      headerProperties = props.headerProperties,
      contentProperties = props.contentProperties,
      subheaderProperties = props.subheaderProperties;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var IsActionColumnPresentAlready = function IsActionColumnPresentAlready(columnData) {
    return columnData.some(function (o) {
      return o.columnKey === 'action';
    });
  };

  var getContentWrapperProps = function getContentWrapperProps(textType, isLastColumn) {
    return {
      family: textType.fontFamily,
      size: textType.fontSize,
      weight: textType.fontWeight,
      height: textType.lineHeight,
      color: textType.fontColor,
      alignment: isLastColumn ? _constant.ALIGNMENT.right : _constant.ALIGNMENT.left,
      isEllipsis: isEllipsis,
      ellipsisLength: ellipsisLength
    };
  };

  var getHeader = function getHeader() {
    if (rowsWithAction && !IsActionColumnPresentAlready(columns)) {
      // eslint-disable-next-line react/prop-types
      columns.push({
        columnKey: 'action',
        columnName: ''
      });
    }

    var headers = columns || [];
    return /*#__PURE__*/_react.default.createElement(RowWrapper, {
      showBorder: showBorder
    }, headers.map(function (_ref47, idx) {
      var columnKey = _ref47.columnKey,
          columnName = _ref47.columnName,
          width = _ref47.width,
          columnSubheader = _ref47.columnSubheader;
      var isLastColumn = idx === headers.length - 1;
      var textType = _constant.TEXT_TYPE.title;
      var subHeaderTextType = _constant.TEXT_TYPE.subheader;
      return /*#__PURE__*/_react.default.createElement(HeaderWrapper, (0, _extends2.default)({
        key: columnKey,
        family: textType.fontFamily,
        size: textType.fontSize,
        weight: textType.fontWeight,
        height: textType.lineHeight,
        color: textType.fontColor,
        alignment: isLastColumn && !withSubLabel ? _constant.ALIGNMENT.right : _constant.ALIGNMENT.left,
        boxSizing: boxSizing ? _constant.BOX_SIZING.borderBox : _constant.BOX_SIZING.contentBox,
        width: width !== null && width !== void 0 ? width : 'auto'
      }, headerProperties && _objectSpread(_objectSpread({}, headerProperties), {}, {
        alignment: // eslint-disable-next-line react/prop-types
        idx === 0 && !headerProperties.overrideDefaultAlignment ? _constant.ALIGNMENT.left : // eslint-disable-next-line react/prop-types
        (headerProperties === null || headerProperties === void 0 ? void 0 : headerProperties.alignment) || _constant.ALIGNMENT.left
      })), language[columnKey] || columnName, columnSubheader && /*#__PURE__*/_react.default.createElement(SubheaderWrapper, (0, _extends2.default)({
        family: subHeaderTextType.fontFamily,
        size: subHeaderTextType.fontSize,
        weight: subHeaderTextType.fontWeight,
        height: subHeaderTextType.lineHeight,
        color: subHeaderTextType.fontColor,
        alignment: isLastColumn && !withSubLabel ? _constant.ALIGNMENT.right : _constant.ALIGNMENT.left
      }, subheaderProperties && _objectSpread(_objectSpread({}, subheaderProperties), {}, {
        alignment: // eslint-disable-next-line react/prop-types
        idx === 0 && !subheaderProperties.overrideDefaultAlignment ? _constant.ALIGNMENT.left : // eslint-disable-next-line react/prop-types
        (subheaderProperties === null || subheaderProperties === void 0 ? void 0 : subheaderProperties.alignment) || _constant.ALIGNMENT.left
      })), columnSubheader));
    }));
  };

  var getRowsWithAction = function getRowsWithAction() {
    return data.map(function (rowKey, rowIdx) {
      var rowData = data[rowIdx];
      rowData.columns.action = '';
      var keys = Object.keys(rowData.columns);
      var row = rowData.columns;
      return /*#__PURE__*/_react.default.createElement(RowWrapperAction, {
        bottomBorder: rowIdx === data.length - 1 ? true : rowData.bottomBorder,
        onClick: function onClick(e) {
          var _e$target, _e$target2, _e$target3, _e$target4, _e$target5, _e$target6;

          if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id) !== 'action' && (e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.nodeName) !== 'svg' && (e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.id) !== 'airasia-dropdown-options' && (e === null || e === void 0 || (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.nodeName) !== 'path' && (e === null || e === void 0 || (_e$target5 = e.target) === null || _e$target5 === void 0 ? void 0 : _e$target5.nodeName) !== 'P' && (e === null || e === void 0 || (_e$target6 = e.target) === null || _e$target6 === void 0 ? void 0 : _e$target6.nodeName) !== 'LI') {
            _onOptionSelect(language.general, rowData.actions);
          }
        }
      }, keys.map(function (key, idx) {
        var _row$key, _row$key2;

        var headerData = columns.find(function (o) {
          return o.columnKey === key;
        });
        var enableLabel = headerData.enableLabel;
        var textType = _constant.TEXT_TYPE.text;
        var isLastColumn = idx === columns.length - 1;
        var value = ((_row$key = row[key]) === null || _row$key === void 0 ? void 0 : _row$key.value) || row[key] || '';
        textType.fontColor = ((_row$key2 = row[key]) === null || _row$key2 === void 0 ? void 0 : _row$key2.fontColor) || (headerData === null || headerData === void 0 ? void 0 : headerData.fontColor) || '';
        return /*#__PURE__*/_react.default.createElement(ContentWrapper, (0, _extends2.default)({}, getContentWrapperProps(textType, isLastColumn), {
          id: key
        }), !enableLabel && (language[value] || value), enableLabel && /*#__PURE__*/_react.default.createElement(_Label.default, {
          labelColor: rowData.labelColour.label,
          textColor: rowData.labelColour.text
        }, ' ', language[value] || value, ' '), rowsWithAction && isLastColumn && /*#__PURE__*/_react.default.createElement(_DropdownOptions.default, (0, _extends2.default)({}, dropdownOptionsProps, {
          data: rowData.dropdownData,
          onOptionSelect: function onOptionSelect(val) {
            _onOptionSelect(val, rowData.actions);
          }
        })));
      }));
    });
  };

  var getRows = function getRows() {
    if (rowsWithAction) {
      return getRowsWithAction();
    }

    return data.map(function (row) {
      // filter only columns that are defined, so it will render the correct column count
      var keys = Object.keys(row).filter(function (key) {
        return columns.map(function (col) {
          return col.columnKey;
        }).includes(key);
      });
      return /*#__PURE__*/_react.default.createElement(RowWrapper, {
        showBorder: showBorder
      }, keys.map(function (key, idx) {
        var textType = key === _constant.COLUMNS.bookingNumber ? _constant.TEXT_TYPE.bookingTitle : _constant.TEXT_TYPE.text;
        var isLastColumn = idx === columns.length - 1;
        var value = (0, _typeof2.default)(row[key]) === 'object' && row[key].value ? row[key].value : row[key] || '';
        var children = (0, _typeof2.default)(row[key]) === 'object' && row[key].children ? row[key].children : '';
        var position = (0, _typeof2.default)(row[key]) === 'object' && row[key].childrenPosition ? row[key].childrenPosition : '';
        return /*#__PURE__*/_react.default.createElement(ContentWrapper, (0, _extends2.default)({}, getContentWrapperProps(textType, isLastColumn), contentProperties && _objectSpread(_objectSpread({}, contentProperties), {}, {
          // eslint-disable-next-line react/prop-types
          alignment: idx === 0 ? _constant.ALIGNMENT.left : (contentProperties === null || contentProperties === void 0 ? void 0 : contentProperties.alignment) || _constant.ALIGNMENT.left
        })), /*#__PURE__*/_react.default.createElement(ContentChildrenWrapper, null, /*#__PURE__*/_react.default.createElement(ChildrenWrapper, null, position === _constant.SUBTITLE_POSITION.prefix && children), language[value] || value, /*#__PURE__*/_react.default.createElement(ChildrenWrapper, null, " ", position === _constant.SUBTITLE_POSITION.postfix && children)));
      }));
    });
  };

  var getDetailedRows = function getDetailedRows() {
    return data.map(function (row) {
      var textType = _constant.TEXT_TYPE.text;
      var list = Array.from(row.bookingNumber);
      var children = (0, _typeof2.default)(row.guestName.children) === 'object' && row.guestName.children ? row.guestName.children : '';
      return /*#__PURE__*/_react.default.createElement(RowWrapper, {
        showBorder: showBorder
      }, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
        family: textType.secondary,
        size: textType.fontSize,
        weight: textType.fontWeight,
        height: textType.lineHeight,
        color: textType.fontColor
      }, row.guestName.value, " ", children), /*#__PURE__*/_react.default.createElement(ContentWrapper, {
        family: textType.secondary,
        size: textType.fontSize,
        weight: textType.fontWeight,
        height: textType.lineHeight,
        color: textType.fontColor
      }, list && list.map(function (value) {
        var children2 = (0, _typeof2.default)(value.children) === 'object' && value.children ? value.children : '';
        var position2 = value.childrenPosition;
        return /*#__PURE__*/_react.default.createElement(FlexContainer, {
          isMobile: isMobile
        }, /*#__PURE__*/_react.default.createElement(FlexColumn, null, value.pnr), /*#__PURE__*/_react.default.createElement(NotFirstColumn, {
          family: textType.fontFamily,
          size: textType.fontSize,
          weight: textType.fontWeight,
          color: textType.fontColor
        }, position2 === _constant.SUBTITLE_POSITION.postfix && children2));
      })));
    });
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({
      tabIndex: tabIndex,
      isTableFixed: isTableFixed
    }, customProperties), /*#__PURE__*/_react.default.createElement(TableHead, null, getHeader()), /*#__PURE__*/_react.default.createElement(TableBody, null, withSubLabel ? getDetailedRows() : getRows()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Table.propTypes = _table.TableProptypes.PropTypes;
Table.defaultProps = _table.TableProptypes.DefaultProps;
var _default = Table;
exports.default = _default;